import { GraphNode } from './GraphNode';
import { mapEdgeElements } from './GraphEdge';

export const mapFlowConfig = (
  flowConfig,
  { country, hoveredNodeId, region, showExcludedSteps, widgetType, getBackendUrlByRegion },
) => {
  const nodes = flowConfig.steps
    .filter(({ exclude }) => showExcludedSteps || !exclude)
    .map(
      step =>
        new GraphNode(step, flowConfig, {
          country,
          region,
          showDetails: hoveredNodeId === step.path && !step.exclude,
          widgetType,
          getBackendUrlByRegion,
        }),
    );

  // Get edges and filter out the ones that come from or point to a non-existing node
  const edges = mapEdgeElements(flowConfig.steps).filter(
    ({ source, target }) =>
      !!nodes.find(({ id }) => id === source) && !!nodes.find(({ id }) => id === target),
  );

  // Now also filter out the nodes that don't have any incoming and outgoing edges
  const filteredNodes = nodes.filter(
    node => !!edges.find(edge => edge.source === node.id || edge.target === node.id),
  );

  return [...filteredNodes, ...edges];
};
